import { useDropzone } from 'react-dropzone';
import { useCallback, useEffect, useState } from 'react';
import { Button, IconButton, Tooltip } from '@material-ui/core';
import { FileUpload } from './UploadFiles';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import { I18n } from 'aws-amplify';

export const DropFile = ({ fileUploadList, setFileUploadList, setValue, register, name, ...props }) => {
    register(name);

    // const publicForCustomer = props.data.structure.publicForCustomer;
    
    const [publicForCustomer, setPublicForCustomer] = useState(0);
    const [isDisable, setIsDisable] = useState(false);
    const isUploadForEmailTicket = props.selectTicketType === Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL || props.ticketType === Constant.TICKET_TYPE.EMAIL;

    useEffect(() => {
        setPublicForCustomer(props.data.structure.publicForCustomer);

        setIsDisable(checkDisableField());

    }, [props.data.structure.publicForCustomer, props.detailTicket])

    const onDrop = useCallback(
        (acceptedFiles) => {
            handleDragFileOnChange(acceptedFiles);
            return;
        },
        [fileUploadList]
    );
    const { getRootProps, getInputProps } = useDropzone({ onDrop, disabled: isDisable });

    const handleDragFileOnChange = (fileList) => {
        console.log('fileList', fileList)
        // if(checkDisableField()) return;
        let tempFileUploadList = [];
        for (let i = 0; i < fileList.length; i++){
            if (fileList[i]) {
                let fileUpload = { file: fileList[i], progress: 0, status: true, key: '' };
                setValue(name, 'fileUploaded');
                tempFileUploadList.push(fileUpload);
            }
            let newFileUploadList = [...fileUploadList, ...tempFileUploadList];
            setFileUploadList(newFileUploadList);
            setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, newFileUploadList);
        }

        if(!Utils.isEmptyArray(tempFileUploadList)) {
            props.clearErrors(name);
            setValue(name, 'fileUploaded');
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            if(props?.setOnChangeEdit){
                if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props?.onChangeEdit)
                }
            }
        } else {
            setValue(name, '');
        }
    };

    useEffect(() => {
        if (!Utils.isEmptyArray(fileUploadList) && isUploadForEmailTicket && props.setErrorCreateTicket) {
            let totalFileSize = 0;
            fileUploadList.forEach(file => {
                if (file?.file?.size) {
                    totalFileSize += parseInt(file?.file?.size);
                }
            })
            if (totalFileSize) {
                let convertTotalFileSizeToMB = Utils.convertByteToMB(totalFileSize)
                if (convertTotalFileSizeToMB > Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) {
                    console.log('---- set error msg')
                    props.setErrorCreateTicket(
                        name,
                        { type: 'manual', message: I18n.get('MGS-FILE-OVER-CAPACITY').replace('{{fileSize}}', Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) },
                        { shouldFocus: true }
                    );
                }
            } else {
                props.clearErrors(name); 
            }
        } else {
            props.clearErrors(name);
        }
    }, [fileUploadList]);

    const handleDeleteFile = (index) => {
        let newFileUploadList = cloneDeep(fileUploadList);
        newFileUploadList.splice(index, 1);
        setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, newFileUploadList);
        // setValue(name, newFileUploadList);
        setFileUploadList([...newFileUploadList]);

        if(!Utils.isEmptyArray(newFileUploadList)) {
            setValue(name, 'fileUploaded');
            props.clearErrors(name);
        } else {
            setValue(name, '');
        }
    };

    const renderImage = () => {
        let contentChatList = [];
        if (!isDisable) {
            fileUploadList.forEach((fileUploadInfor, index) => {
                let item = { content: fileUploadInfor.file.name, fileSize: fileUploadInfor.file.size };
                contentChatList.push(
                    <li>
                        <FileUpload
                            key={index}
                            fileUploadInfor={fileUploadInfor}
                            fileUploading={props.fileUploading}
                            chatPost={item}
                        ></FileUpload>
                        <div className="lstName-item">
                            <IconButton onClick={() => handleDeleteFile(index)} className="itemDelete">
                                <img src="/assets/image/icon-closeUpfile.svg" alt="" />
                            </IconButton>
                        </div>
                    </li>
                );
            });
        }
        return contentChatList;
    };

    const isCustomerHasFileUpload = (contentChatList) => {
        if (!Utils.isEmpty(props.addTicket)) {
            return false;
        }

        return props.componentName !== Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
        publicForCustomer !== Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE && 
        Utils.isEmptyArray(contentChatList)
    }

    const isCustomerKnowledgeHasFileUpload = (contentChatList) => {
        if (!Utils.isEmpty(props.addTicket)) {
            return false;
        }

        return props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
        !props?.hasEditFieldPermissions && 
        Utils.isEmptyArray(contentChatList)
    }

    const renderLabel = () => {
        const contentChatList = renderImage();
        if (isCustomerHasFileUpload(contentChatList) || isCustomerKnowledgeHasFileUpload(contentChatList)) {
            return '';
        }

        return (
            <>
                {props?.isTooltipTitle ? (
                    <div className="d-flex">
                        <Tooltip title={props?.label}>
                            <span className="form-addTicket-label text-truncate">
                                <label
                                    className={
                                        'text-truncate line-height-18' +
                                        (publicForCustomer
                                            ? 'form-addTicket-label-color'
                                            : 'form-addTicket-label')
                                    }
                                >
                                    {props?.label}
                                </label>
                            </span>
                        </Tooltip>
                        {props.data.structure.required && (
                            <span className="required padding-left-4">*</span>
                        )}
                    </div>
                ) : (
                    <label
                        className={
                            publicForCustomer
                                ? 'form-addTicket-label-color'
                                : 'form-addTicket-label'
                        }
                    >
                        {props?.label}
                        {props.data.structure.required && <span className="required">*</span>}
                    </label>
                )}
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement="top" arrow>
                        <img
                            style={{ paddingTop: '10px' }}
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </>
        );
    }

    const checkDisableField = () => {
        return (props.data.structure.publicForCustomer === 2 || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false );
    }

    const isDisplayBoxUploadFile = () => {
        if (!Utils.isEmpty(props.addTicket)) {
            return true;
        }

        if (props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE) {
            return props?.hasEditFieldPermissions;
        }

        return publicForCustomer === Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
    }

    return (
        <div className="form-addTicket">
            <div className="cell-prod-status gap-8">
                {renderLabel()}
            </div>
            
            <div className="form-addTicket-input">
                <div className="lstName-file">
                    <ul>{renderImage()}</ul>
                </div>

                { isDisplayBoxUploadFile() && (<div className="formUpload" {...getRootProps()} data-cy="drop-file-input-upload">
                    <input disabled={isDisable} {...getInputProps()} draggable="false"/>
                    <label htmlFor="contained-button-file">
                        <Button disabled={isDisable} variant="contained" component="span">
                            <div className="formUpload-item">
                                <img src="/assets/image/icon-upload.svg" alt="" onDragStart={e => {e.preventDefault();}} />
                                <span className="formUpload-txt">
                                    {I18n.get('MSG-DRAG-DROP-FILE')}
                                </span>
                            </div>
                        </Button>
                    </label>
                </div>)}
                {props?.errorlist && props.errorlist[name]?.message && 
                    <div className='upload-file-error'>
                        {props.errorlist[name]?.message}
                    </div>
                }
            </div>
        </div>
    );
};
